
const tokenManagerHelper = (function() {

    return {
        getSigningKey: _getSigningKey
    };

    function _getSigningKey(jwkUrl, alg, kid) {
        // check for the presence of key for kid in the storage
        // if present the retrun the key from the storage else
        // get the keys by calling the jwkUri of the authentication provider
        const key = getKeyFromStorage(kid);
        return key ?
        Promise.resolve(key):
         _getSigningKeys(jwkUrl)
        .then((jwks)=>{
            const keys = jwks.keys;
            const key = _getKeysForAlg(keys, alg, kid);
            // store the key for the kid in the local storage
            // to be used next time without making an ajax call
            localStorage.setItem(kid, JSON.stringify(key));
            return Promise.resolve(key);
        });
    }

    function getKeyFromStorage(kid) {
        try {
            const key = localStorage.getItem(kid);
            return JSON.parse(key);
        }
        catch (e) {
            return false;
        }
    }

    function _getSigningKeys(jwkUrl) {
        return fetch(jwkUrl, {
            method: 'GET',
            mode: 'cors'
        })
        .then((res)=>{
            return res.json();
        });
    }   

    function _getKeysForAlg(jwks, alg, kid) {
        return jwks.filter((key)=>{
            return key.kid === kid;
        })[0];
    }

})();

module.exports = tokenManagerHelper;